import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ButtonLink from '../ButtonLink';
import SafeHTML from '../SafeHTML';
import ImageBlock from '../ImageBlock';
import CustomPropTypes from '../../utils/customPropTypes';
import scrollToElement from 'scroll-to-element';
import style from '../../../scss/components/Products/ProductHero';
import IntersectionVisible from '../IntersectionVisible'
export default class ProductHero extends React.Component {
    static propTypes = {
        image: CustomPropTypes.Image,
        description: PropTypes.string,
        title: PropTypes.string,
        price: PropTypes.string
    }
    constructor(props) {
        super(props);
        this.state = {
            productName: "",
            menuOpen: false
        };
    }
    componentDidMount() {
        let pageName = document.querySelector('body').getAttribute("page-name");
        this.setState({ productName: pageName });
    }
    onButtonClick = (e) => {
        e.preventDefault();
        let el = document.querySelector('.main > section:nth-of-type(2)');
        scrollToElement(el);
    }
    getClassname = (suffix = '') => {
        let cls = "product-hero" + `${suffix}`;
        if (this.props.className) {
            cls = cls + ` ${this.props.className}${suffix}`
        }
        return cls;
    }
    handleActiveLink(index) {
        let navItems = document.querySelectorAll(".specs-navbar li")
        for (let i=1; i <= navItems.length; ++i){
            if (i === index+2){
                document.querySelector(`.specs-navbar li:nth-child(${i})`).classList.add("specs-navbar-active");
            }else{
                document.querySelector(`.specs-navbar li:nth-child(${i})`).classList.remove("specs-navbar-active");
            }
        }
    }
    navLinkClick = (e, navSec, index) => {
        e.preventDefault();
        this.setState({ menuOpen: false });//hide opened menu upon navigation
        let el = document.querySelector('section[data-component-type="' + navSec + '"]');
        let prodNavEl = document.querySelector('.intersection-visible-wrapper');
        scrollToElement(el, {
            offset: -prodNavEl.clientHeight
        });
        this.handleActiveLink(index)
    }
    getTabLinks = () => {
        let linksArr = [
            { key: 'ProductIntro', value: '概览' },
            { key: 'ProductFeatures', value: '功能' },
            { key: 'Specifications', value: '产品规格' },
            { key: 'GenericCarousel', value: '相关文件' }];
            let tabLinks = linksArr.map((item, index) => {
                let componentExists = document.querySelector('section[data-component-type="' + item.key + '"]');
                if(componentExists)
                    return <li key={item.key}><a onClick={(e) => this.navLinkClick(e, item.key, index)}>{item.value}</a></li> 
            });

        return <ul className="specs-navbar">
            <li className="product-price">
                {this.props.price}
            </li>
            {tabLinks}
        </ul>;
    }
    toggleMenu() {
        let isMenuOpen = this.state.menuOpen;
        this.setState({ menuOpen: !isMenuOpen });
    }
    getGoToParentLink = () => {
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        if (parentPage) {
            var [url, title] = parentPage.split(';');
            return <div className="has-back-link">
            <div className="container"><a href={url} className="btn btn-link-normal btn-back-link">
              <i className="icon icon-prev"></i>&nbsp;{title}
            </a></div>
            </div>
        }
        return null;
    }
    getQuoteButton = () => {
        var ctrlFooter = document.querySelector('[data-component-type="MainNavigation"]')
        let mainNavConfig = ctrlFooter.dataset.config || '{}';
        mainNavConfig = JSON.parse(mainNavConfig);
        if (mainNavConfig) {
            return <ButtonLink className="btn btn-outline-product product-quote-btn" text={"获取报价"} url={mainNavConfig.contact_page_url} />
        }
        return null;
    }
    updateStickyClass = (isSticky) => {
        const winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        if (winScroll < 500)
            isSticky = false;//if scrolling up towards banner/hero then no need of sticky
        let el = document.querySelector('.specs-navbar-section');
        if (el) {
            if (isSticky)
                el.className += " active";
            else
                el.classList.remove("active");
        }
    }
    render() {
        return (
            <>
                <section className={this.getClassname()}>
                    {this.getGoToParentLink()}
                    <div className="container banner-wrapper">
                        <div className="row">
                            {this.props.image && <div className="col">
                                <ImageBlock image={this.props.image} addWrapper={false} imgClassName="object-embed center"></ImageBlock>
                            </div>
                            }
                            <div className="col">
                                {this.state.productName && <h5 className="hunterlab-title banner-title">
                                <SafeHTML>
                                    {this.state.productName}
                                </SafeHTML>
                                </h5>
                                }

                                <div className="banner-main-title"><SafeHTML>{this.props.title}</SafeHTML></div>

                                {this.props.description && <div className="banner-desc">
                                    <SafeHTML>
                                        {this.props.description}
                                    </SafeHTML>
                                </div>}
                                <a
                                    href="#"
                                    className="btn btn-circle btn-scrollToBottom"
                                    onClick={this.onButtonClick}>
                                    <i className="icon icon-down"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <IntersectionVisible
                    onShow={() => this.updateStickyClass(false)}
                    onHide={() => this.updateStickyClass(true)}>
                    <section className="specs-navbar-section">
                        <div className="specs-nav-section-inner">
                            <div className="container">
                                <div className={"specs-navbar-wrap" + (this.state.menuOpen ? " open" : "")}>
                                    <label className="specs-navbar-label" onClick={() => this.toggleMenu()}>{this.state.productName}</label>
                                    {this.getTabLinks()}
                                    {this.getQuoteButton()}
                                </div>
                            </div>
                        </div>
                    </section>
                </IntersectionVisible>
            </>
        )
    }
}
